<template>
  <ol class="beautiful-list">
    <li v-for="item in items" v-bind:key="item.id">
      <span class="beatiful-list-index">{{ item.id }}</span>
      <span class="beatiful-list-text">{{ item.text }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  name: "BeautifulList",
  props: ["items"],
};
</script>

<style>
.beautiful-list {
  list-style-type: none;
  counter-reset: list-counter;
  padding-left: 0px;
}

.beautiful-list li {
  background-color: #fafafa;
  border-radius: 0.5rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  display: flex;
}

.beatiful-list-index {
  border-radius: 0.5rem 0 0 0.5rem;
  background-color: #fdd835;
  padding: 0.5rem 0.7rem;
}

.beatiful-list-text {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.7rem;
}
</style>
